import { CSInterface } from "csinterface-ts";
import { rootStore } from "../../store/root";
import { jsxConstsEvents, jsxConstFunctions } from "../jsxConsts";

const { csInterface }: { csInterface: CSInterface } = window as any;

export function renderUpdate() {
  const {
    uiStore: {
      setRenderProgress,
      addToAlertMessage,
      setAlertModalVisible,
      alertModalVisible,
    },
  } = rootStore;
  csInterface.addEventListener(jsxConstsEvents.renderUpdate, (ev: any) => {
    console.log(ev);
    if (ev.data.message.indexOf("Rendering layer:") > -1) {
      setRenderProgress(ev.data.progress);
    }
    if (ev.data.message.indexOf("Render Failed") > -1 && !alertModalVisible) {
      const message = ev.data.message.replace("<br />", "\n");
      addToAlertMessage(message);
      setAlertModalVisible();
      csInterface.evalScript(jsxConstFunctions.cancelRender, (res) => {
        console.log("");
      });
    }
  });
}
